import { render, staticRenderFns } from "./CustomNavbar.vue?vue&type=template&id=0974481a&scoped=true&"
import script from "./CustomNavbar.vue?vue&type=script&lang=js&"
export * from "./CustomNavbar.vue?vue&type=script&lang=js&"
import style0 from "./CustomNavbar.vue?vue&type=style&index=0&id=0974481a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0974481a",
  null
  
)

export default component.exports